export const pageDefaultSettings = {
  style: {
    overflow: "hidden",
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(0, 0, 0)",
    width: "600px",
    height: "800px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
};

export const boxDefaultSettings = {
  style: {
    overflow: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    display: "flex",
    gap: "10px",
    flex: 1,
    flexWrap: "nowrap",
    maxWidth: "100%",
    maxHeight: "100%",
  },
};

export const subboxDefaultSettings = {
  style: {
    ...boxDefaultSettings.style,
    flexDirection: "column",
  },
};

export const contentDefaultSettings = {
  style: {
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    overflow: "auto",
  },
};

export const languageDefaultSettings = {
  style: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
};

export const imageDefaultSettings = {
  style: {
    maxWidth: "100%",
    maxHeight: "100%",
    width: "100px",
    height: "100px",
    overflow: "hidden",
  },
};

export const bcCompanyDefaultSettings = {
  attributes: {
    show_business_center_company_name: true,
  },

  style: {
    width: "200px",
    height: "250px",
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: "rgba(0, 0, 0, 1)",
    overflow: "hidden",
  },
};

/**
 * This method will return the default layout settings for the given type
 * @param {string} type
 * @returns {object}
 */
export function getDefaultLayoutSettings(type) {
  switch (type) {
    case "page":
      return pageDefaultSettings;
    case "box":
      return boxDefaultSettings;
    case "subbox":
      return subboxDefaultSettings;
    case "content":
      return contentDefaultSettings;
    case "language":
      return languageDefaultSettings;
    case "image":
      return imageDefaultSettings;
    case "bc_company":
      return bcCompanyDefaultSettings;
    default:
      return {};
  }
}
